import React from 'react';
import "./Hero.css"

const Hero = () => {
  return (
    <div>
      <section className="inner-banner dark-bg">
  <div className="container">
    <div className="section-info">
      <div className="row align-items-center">
        <div className="col-md-7 col-sm-12 ff-mos">
          <h1 className="ff-mos">
            Secure the Network <br />
            &amp; Earn Reward with <br />
            <span className="white-bg">BONE Staking</span>
          </h1>
          <a href='https://shibaswap.com/#/swap?outputCurrency=0x9813037ee2218799597d83D4a5B6F3b6778218d9' target='_blank'>
          <button className='MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeSmall MuiButton-textSizeMedium MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-4hkj1c' style={{marginTop:"20px", width:"30%"}}>Buy Bone</button>

          </a>
         
        </div>
        <div className="col-md-5 col-sm-12 m-hide">
          <div className="shib-img-sec text-end">
            <img src="https://shibarium.shib.io/assets/images/shib-bg.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </div>
  )
}

export default Hero
